module.exports = __webpack_public_path__ + "img/img14.46b84257.png";